import {combineReducers} from "redux";
import ordersReducer from "./ordersReducer";
import businessReducer from "./businessReducer";
import profilesReducer from "./profilesReducer";
import userReducer from "./usersReducer";
import deliveryGroupsReducer from "./deliveryGroupsReducer";
import activeMessengersReducer from "./activeMessengersReducer";
import authenticationReducer from "./authenticationReducer";
import distributionAreasReducer from "./distributionAreasReducer";

const reducers = combineReducers({
    "deliveryGroupsReducer": deliveryGroupsReducer,
    "ordersReducer": ordersReducer,
    "usersReducer": userReducer,
    "businessReducer": businessReducer,
    "profilesReducer": profilesReducer,
    "activeMessengersReducer": activeMessengersReducer,
    "authenticationReducer": authenticationReducer,
    "distributionAreasReducer": distributionAreasReducer
});

export default reducers;